import { ItemAnalyticsModel } from '@/@types/client-api';
import { createSlice } from '@reduxjs/toolkit';

export interface CartPanel {
  isOpen: boolean;
  isAddingToCart?: boolean;
  lastAddedItem?: ItemAnalyticsModel;
}

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    isOpen: false,
    isAddingToCart: false,
    lastAddedItem: undefined
  } as CartPanel,
  reducers: {
    openCartPanel(state) {
      state.isOpen = true;
    },
    closeCartPanel(state) {
      state.isOpen = false;
    },
    setIsAddingToCart(state, action) {
      state.isAddingToCart = action.payload;
    },
    setLastAddedItem(state, action) {
      state.lastAddedItem = action.payload;
    }
  }
});

export const { openCartPanel, closeCartPanel, setIsAddingToCart, setLastAddedItem } =
  cartSlice.actions;
export default cartSlice.reducer;
